import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconInvoice: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.3905 19.7727 21.7453 19.4179 21.9085C19.0631 22.0717 18.6457 22.0134 18.3492 21.7593L17.3175 20.8749C16.943 20.5539 16.3904 20.5539 16.0159 20.8749L14.9841 21.7593C14.6096 22.0802 14.057 22.0802 13.6825 21.7593L12.6508 20.8749C12.2763 20.5539 11.7237 20.5539 11.3492 20.8749L10.3175 21.7593C9.94297 22.0802 9.39036 22.0802 9.01588 21.7593L7.98412 20.8749C7.60963 20.5539 7.05703 20.5539 6.68254 20.8749L5.65079 21.7593C5.35428 22.0134 4.93694 22.0717 4.58214 21.9085C4.22734 21.7453 4 21.3905 4 21V3ZM9 6C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H9ZM9 10C8.44772 10 8 10.4477 8 11C8 11.5523 8.44772 12 9 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H9ZM10 15C10 14.4477 10.4477 14 11 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H11C10.4477 16 10 15.5523 10 15Z"
        fill="#200E32"
      />
    </Icon>
  );
};

export default IconInvoice;
